import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { PresentationRebrand } from '@components/PresentationRebrand';
import { FeatureFlags } from '@constants/featureFlags.ts';
import { paths } from '@constants/paths';
import { useFeatureFlag } from '@hooks/useFeatureFlag.ts';
import { useLoader } from '@hooks/useLoader';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { withProfiler } from '@services/sentry/withProfiler';
import { RequestState } from '~/src/types';

import { getPartnerPresentationSlides } from '../PartnerPresentation/slides';

const PartnerPresentationRebrandUnwrapped = () => {
  const navigate = useNavigate();
  const { setRequestState } = useLoader();
  const { basketId } = useBasketContext();
  const { value: isPartnerPresentationReworkEnabled } = useFeatureFlag(
    FeatureFlags.PARTNER_PRESENTATION_REWORK_ENABLED,
    false
  );

  useEffect(() => {
    setRequestState(RequestState.success);
  }, [setRequestState]);

  const handleClose = () => navigate(basketId ? paths.bundle : paths.address);

  return (
    <PresentationRebrand
      slides={getPartnerPresentationSlides(isPartnerPresentationReworkEnabled)}
      onClose={handleClose}
      showDivider
    />
  );
};

const PartnerPresentationRebrand = withProfiler(
  PartnerPresentationRebrandUnwrapped
);

export { PartnerPresentationRebrand };
